export const categories = [
  { slug: 'rumen', name: '入门指南', description: '从零开始了解po文学的基础概念与发展脉络', icon: 'ri-book-open-line' },
  { slug: 'jiqiao', name: '创作技巧', description: '掌握po文学写作的核心方法与实用技巧', icon: 'ri-quill-pen-line' },
  { slug: 'anli', name: '经典案例', description: '深入分析优秀po文学作品的成功要素', icon: 'ri-star-line' },
  { slug: 'fengge', name: '风格解析', description: '探索不同po文学风格的特色与表现手法', icon: 'ri-palette-line' },
  { slug: 'qushi', name: '行业趋势', description: '把握网络文学与po文学的最新发展方向', icon: 'ri-line-chart-line' },
];